export const authenticationInitialState = {
  userIsLoggedIn: false,
  sessionHasExpired: false,
  sessionWillExpireAt: undefined,
};
